import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/content";

const EASE = [0.22, 1, 0.36, 1];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="border-y border-stone-200 bg-[#F3F1EC] py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="mb-14 max-w-2xl"
        >
          <p className="font-mono-accent mb-4 text-xs uppercase tracking-[0.24em] text-amber-600">
            Testimonials
          </p>
          <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            Word on the{" "}
            <span className="font-serif-accent font-medium italic text-slate-500">Corridor</span>
          </h2>
        </motion.div>

        <div className="grid gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.author}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.75, delay: i * 0.12, ease: EASE }}
              className="flex flex-col rounded-3xl border border-stone-200 bg-white p-8 shadow-sm transition-shadow duration-300 hover:shadow-xl hover:shadow-slate-900/5"
            >
              <Quote className="mb-5 h-7 w-7 text-amber-500/60" />
              <blockquote className="font-serif-accent flex-1 text-base italic leading-relaxed text-slate-700">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7 border-t border-stone-100 pt-5">
                <div className="mb-2 flex gap-1" aria-label="5 out of 5 stars">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="h-3.5 w-3.5 fill-amber-500 text-amber-500" />
                  ))}
                </div>
                <p className="font-display text-sm font-bold text-slate-900">{t.author}</p>
                <p className="font-mono-accent mt-0.5 text-[11px] uppercase tracking-[0.14em] text-slate-400">
                  {t.role}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
